import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentLayout } from '@ibk/shared-layout';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Button, Card, Icon } from '@ibk/shared-ui';
import { beneficiosTranslations } from '../../translations';
import styles from './PersonHiringBlocked.module.css';
function PersonHiringBlockedContent({ onBackToBenefits }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleBackClick = useCallback(() => {
        if (onBackToBenefits) {
            onBackToBenefits();
        }
        else {
            navigate('/beneficios');
        }
    }, [onBackToBenefits, navigate]);
    const breadcrumbs = [{ label: 'Benefícios', href: '/beneficios' }, { label: 'Contratação' }];
    return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, showSidebar: false, className: styles.personHiringBlockedContainer, style: { maxWidth: '100%' }, children: _jsxs(Card, { className: styles.card, children: [_jsx("div", { className: styles.iconContainer, children: _jsx(Icon, { name: 'actionBlock', alt: 'Bloqueado', className: styles.icon }) }), _jsx("h1", { className: styles.title, children: t('blocked.person.title') }), _jsx("p", { className: styles.description, children: t('blocked.person.description') }), _jsx(Button, { variant: 'primary', size: 'large', onClick: handleBackClick, dataTestId: 'back-button', children: t('blocked.person.back-button') })] }) }));
}
export const PersonHiringBlocked = props => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(PersonHiringBlockedContent, { ...props }) }));
};
